import dateUtil from '../dateUtil';

export const MORNING = dateUtil().hour(6).minute(0);
export const NOON = dateUtil().hour(12).minute(0);
export const EVENING = dateUtil().hour(18).minute(0);
